import React, { useEffect, useContext, useState, useRef } from "react";
import { AppContext } from "../../store/appContext";
import { useDispatchHelpers } from "../../store/dispatchhelper";
import WebLoader from "../../components/webLoader/WebLoader";
import "./booking.scss";
import axios from "axios";
import { ScheduleMeeting } from "react-schedule-meeting";
import translate from "../../services/translation.json";
import { useForm, Controller } from "react-hook-form";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import location_icon from "../../assets/images/location-icon.svg";
import mobile_icon from "../../assets/images/mobile-icon.svg";
import user_icon from "../../assets/images/user-icon.svg";
import role_icon from "../../assets/images/role-icon.svg";
let inputFontColor = "#131A3B";

const Booking = () => {
  const {
    state: { baseUrl, services, lang },
  } = useContext(AppContext);
  const { dispatchAction } = useDispatchHelpers();
  const isDataReady = Object.keys(services).length > 0;
  const [selectedService, setSelectedService] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [bookingFormData, setBookingFormData] = useState({
    name: "",
    role: "",
    location: "",
    mobile: "",
    message: "",
    salutation: "",
    email: "",
    user_id: "",
    service_id: "",
    booking_start: "",
    booking_end: "",
  });
  const [userAvailableTimes, setUserAvailableTimes] = useState([]);
  const servicesCarouselRef = useRef(null);
  const usersCarouselRef = useRef(null);
  const [appointmentContactDetailsOpen, setAppointmentContactDetailsOpen] =
    useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [servicesScrollState, setServicesScrollState] = useState({
    canScrollLeft: false,
    canScrollRight: false
  });
  const [usersScrollState, setUsersScrollState] = useState({
    canScrollLeft: false,
    canScrollRight: false
  });

  const onSubmit = (data) => {
    const bookingData = {
      ...bookingFormData,
      ...data,
    };
    axios
      .post(`${baseUrl}book`, bookingData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {

        if (response.data && response.data.message) {
          setBookingFormData({
            name: "",
            role: "",
            location: "",
            mobile: "",
            message: "",
            salutation: "",
            email: "",
            user_id: "",
            service_id: "",
            booking_start: "",
            booking_end: "",
          });
          setSelectedUser(null);
          setSelectedService(null);
          setUserAvailableTimes([]);
          setAppointmentContactDetailsOpen(false);
        } else {
          alert("Booking failed. Please try again.");
        }
      })
      .catch((error) => {
        console.error("Error during booking:", error);

        if (error.response) {
          console.error("Error Response Data:", error.response.data);
          alert(
            `Booking failed: ${
              error.response.data.message || "Invalid request"
            }`
          );
        } else {
          alert("An unexpected error occurred. Please try again.");
        }
      });
  };

  useEffect(() => {
    axios.get(`${baseUrl}services`).then((response) => {
      dispatchAction("setServicesData", response.data.data);
    });
    //eslint-disable-next-line
  }, []);

  const handleClickedUser = (user) => {
    setSelectedUser(user);
    const availableTimes = user.availableTimes[0].available_times;
    const serviceId = user.availableTimes[0].service_id;
    const userId = user.id;
    let calendarData = [];
    // Prepare the calendar data
    availableTimes.forEach((time) => {
      const { start_date, end_date } = time;
      calendarData.push({
        user_id: userId,
        service_id: serviceId,
        startTime: new Date(start_date),
        endTime: new Date(end_date),
      });
    });
    setUserAvailableTimes(calendarData);
  };

  const handleClickedService = (service) => {
    setSelectedService(service);
    setSelectedUser(null);
  };

  function addHoursToDate(date, hours) {
    return new Date(new Date(date).setHours(new Date(date).getHours() + hours));
  }

  function addMinutesToDate(date, minutes) {
    return new Date(new Date(date).getTime() + minutes);
  }

  const parseDate = (date) => {
    date = new Date(date);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  const handleTimeslotClicked = (startTimeEventEmit) => {
    // reset the calendar
    startTimeEventEmit.resetDate();
    startTimeEventEmit.resetSelectedTimeState();
    const { availableTimeslot, startTime } = startTimeEventEmit;
    const { user_id, service_id } = availableTimeslot;
    const booking_start = parseDate(startTime);
    // add one hour to appointment and 30 mins break
    const booking_end = parseDate(
      addMinutesToDate(addHoursToDate(startTime, 1), 30)
    );
    const serverResponse = selectedService["title_" + lang];
    // Parse the string into a DOM element
    const parser = new DOMParser();
    const doc = parser.parseFromString(serverResponse, "text/html");

    // Get the innerHTML of the parsed content
    const innerHTML = doc.body.firstChild.firstChild.innerHTML;
    // Prepare the new booking form data
    const updatedBookingFormData = {
      ...bookingFormData,
      booking_start,
      booking_end,
      user_id,
      service_id,
      language: lang,
      subject: innerHTML,
    };

    // Update the state
    setBookingFormData(updatedBookingFormData);
    // Show form and hide calendar
    setAppointmentContactDetailsOpen(true);
  };

  const checkScrollability = (ref, setScrollState) => {
    if (ref.current) {
      const { scrollLeft, scrollWidth, clientWidth } = ref.current;
      setScrollState({
        canScrollLeft: scrollLeft > 0,
        canScrollRight: scrollLeft < scrollWidth - clientWidth - 1 // -1 for rounding errors
      });
    }
  };

  useEffect(() => {
    if (servicesCarouselRef.current) {
      checkScrollability(servicesCarouselRef, setServicesScrollState);
    }
  }, [services]);

  useEffect(() => {
    if (usersCarouselRef.current) {
      checkScrollability(usersCarouselRef, setUsersScrollState);
    }
  }, [selectedService]);

  const scrollCarousel = (ref, direction, setScrollState) => {
    if (ref.current) {
      const scrollAmount = direction === "left" ? -300 : 300;
      ref.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
      
      // Update scroll state after animation
      setTimeout(() => {
        checkScrollability(ref, setScrollState);
      }, 300);
    }
  };

  const renderUsers = () => {
    if (
      !selectedService ||
      !selectedService.users ||
      selectedService.users.length === 0
    ) {
      return <p className="no-users">{translate[lang].no_users}</p>;
    }

    return selectedService.users.map((user, i) => {
      // Check if user.availableTimes is a non-empty array and first element is a non-empty object
      const hasAvailableTimes =
        Array.isArray(user.availableTimes) &&
        user.availableTimes.length > 0 &&
        user.availableTimes[0] &&
        Object.keys(user.availableTimes[0]).length > 0;

      return (
        <div
          key={"user_" + i}
          onClick={() => handleClickedUser(user)}
          className={`user-card ${hasAvailableTimes ? "" : "d-none"}`}
        >
          <div className="user-image">
        <img src={user.image} alt={"user_" + i + "_image"} />
          </div>
          <div className="user-details">
        <h3 className="user-name">{user.name}</h3>
        <p className=""></p>
        <p
          className="user-role"
          dangerouslySetInnerHTML={{
            __html: user["description_" + lang],
          }}
        />
          </div>
        </div>
      );
    });
  };

  const renderServices = () => {
    return services.map((service, i) => {
      return (
        <div
          className="service-card"
          key={"service_" + i}
          onClick={() => handleClickedService(service)}
        >
          <div className="service-image">
            <img src={service.image} alt={"service_" + i + "_image"} />
          </div>
          <div className="service-details">
            <h3
              className="service-title"
              dangerouslySetInnerHTML={{
                __html: service["title_" + lang],
              }}
            />
            <p
              className="service-desc"
              dangerouslySetInnerHTML={{
                __html: service["description_" + lang],
              }}
            />
          </div>
        </div>
      );
    });
  };

  const renderBookingForm = () => {
    return (
      <div className="booking-form">
        <h2>{translate[lang].book_title}</h2>
        <form className="form" onSubmit={handleSubmit(onSubmit)}>
          <div className="input-container">
            <Controller
              name="name"
              control={control}
              defaultValue=""
              rules={{ required: translate[lang].book_form.rules.name }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665", borderColor: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor },
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src={user_icon}
                          alt="name-icon"
                          className="input-icon"
                        />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label= {translate[lang].book_form.name}
                  variant="outlined"
                  error={!!errors.name}
                  helperText={errors.name ? errors.name.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <Controller
              name="role"
              control={control}
              defaultValue=""
              rules={{ required: translate[lang].book_form.rules.role }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor },
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src={role_icon}
                          alt="role-icon"
                          className="input-icon"
                        />
                      </InputAdornment>
                    ), // Set font color to white
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label= {translate[lang].book_form.role}
                  variant="outlined"
                  error={!!errors.role}
                  helperText={errors.role ? errors.role.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <Controller
              name="location"
              control={control}
              defaultValue=""
              rules={{ required: translate[lang].book_form.rules.location }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor },
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src={location_icon}
                          alt="location-icon"
                          className="input-icon"
                        />
                      </InputAdornment>
                    ), // Set font color to white
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label={translate[lang].book_form.location}
                  variant="outlined"
                  error={!!errors.location}
                  helperText={errors.location ? errors.location.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <Controller
              name="email"
              control={control}
              defaultValue=""
              rules={{
                required: translate[lang].book_form.rules.email,
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid email address",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  type="email" // Set the input type to email
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor },
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src={user_icon}
                          alt="name-icon"
                          className="input-icon"
                        />
                      </InputAdornment>
                    ), // Set font color to white
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label={translate[lang].book_form.email}
                  variant="outlined"
                  error={!!errors.email}
                  helperText={errors.email ? errors.email.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <Controller
              name="mobile"
              control={control}
              defaultValue=""
              rules={{
                required: translate[lang].book_form.rules.mobile,
                pattern: {
                  value: /^[0-9]{10,15}$/, // Accepts 10 to 15 digits
                  message: "Invalid phone number",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  type="tel" // Set the input type to tel
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor },
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src={mobile_icon}
                          alt="mobile-icon"
                          className="input-icon"
                        />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  label= {translate[lang].book_form.mobile}
                  variant="outlined"
                  error={!!errors.mobile}
                  helperText={errors.mobile ? errors.mobile.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>
          <div className="input-container">
            <Controller
              name="salutation"
              control={control}
              defaultValue=""
              rules={{ required: translate[lang].book_form.rules.salutation }}
              render={({ field }) => (
                <FormControl
                  variant="outlined"
                  sx={{
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                    "& .MuiOutlinedInput-root": {
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#C2A665", // Hover border color
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#C2A665", // Focused border color
                      },
                    },
                  }}
                  fullWidth
                  error={!!errors.salutation}
                >
                  <InputLabel style={{ color: "#C2A665" }}>
                    {translate[lang].book_form.salutation}
                  </InputLabel>
                  <Select
                    {...field}
                    label= {translate[lang].book_form.salutation}
                    style={{ color: inputFontColor }}
                  >
                    <MenuItem value="Mr">{translate[lang].book_form.salutation_options.mr}</MenuItem>
                    <MenuItem value="Ms">{translate[lang].book_form.salutation_options.ms}</MenuItem>
                  </Select>
                  <FormHelperText>
                    {errors.salutation ? errors.salutation.message : ""}
                  </FormHelperText>
                </FormControl>
              )}
            />
          </div>
          <div className="input-container message-container">
            <p>{translate[lang].book_form.message}</p>
            <Controller
              name="message"
              control={control}
              defaultValue=""
              rules={{
                required: translate[lang].book_form.rules.message,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  InputLabelProps={{
                    style: { color: "#C2A665" },
                  }}
                  InputProps={{
                    style: { color: inputFontColor },
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  variant="outlined"
                  multiline
                  rows={4} // Number of rows
                  error={!!errors.message}
                  helperText={errors.message ? errors.message.message : ""}
                  className="mui-textfield"
                />
              )}
            />
          </div>

          <button type="submit" className="submit-btn">
            {translate[lang].book_form.submit}
          </button>
        </form>
      </div>
    );
  };

  return (
    <React.Fragment>
      <WebLoader isLoading={!isDataReady} />
      <div className="booking page">
        {!appointmentContactDetailsOpen && services && isDataReady && (
          <div className="carousel-container">
            {servicesScrollState.canScrollLeft && (
              <button
                className="carousel-arrow left-arrow"
                onClick={() => scrollCarousel(servicesCarouselRef, "left", setServicesScrollState)}
              >
                &#8249;
              </button>
            )}
            <div 
              className="services-carousel" 
              ref={servicesCarouselRef}
              onScroll={() => checkScrollability(servicesCarouselRef, setServicesScrollState)}
            >
              {renderServices()}
            </div>
            {servicesScrollState.canScrollRight && (
              <button
                className="carousel-arrow right-arrow"
                onClick={() => scrollCarousel(servicesCarouselRef, "right", setServicesScrollState)}
              >
                &#8250;
              </button>
            )}
          </div>
        )}
        {!appointmentContactDetailsOpen &&
          isDataReady &&
          services &&
          selectedService && (
            <div className="users-container">
              {usersScrollState.canScrollLeft && (
                <button
                  className="carousel-arrow left-arrow"
                  onClick={() => scrollCarousel(usersCarouselRef, "left", setUsersScrollState)}
                >
                  &#8249;
                </button>
              )}
              <div 
                className="users-carousel" 
                ref={usersCarouselRef}
                onScroll={() => checkScrollability(usersCarouselRef, setUsersScrollState)}
              >
                {renderUsers()}
              </div>
              {usersScrollState.canScrollRight && (
                <button
                  className="carousel-arrow right-arrow"
                  onClick={() => scrollCarousel(usersCarouselRef, "right", setUsersScrollState)}
                >
                  &#8250;
                </button>
              )}
            </div>
          )}
        {!appointmentContactDetailsOpen &&
          selectedUser &&
          userAvailableTimes.length && (
            <div className="calendar-container">
              <ScheduleMeeting
                primaryColor="#A68A43"
                eventDurationInMinutes={60}
                availableTimeslots={userAvailableTimes}
                startTimeListStyle={"scroll-list"}
                onStartTimeSelect={handleTimeslotClicked}
                lang_cancelButtonText={translate[lang].cancel}
                lang_confirmButtonText={translate[lang].confirm}
                lang_emptyListText={translate[lang].noTimesAvailable}
                lang_goToNextAvailableDayText={translate[lang].nextAvailable}
                lang_noFutureTimesText={translate[lang].noFutureTimesAvailable}
                lang_selectedButtonText={`${translate[lang].selected}:`}
              ></ScheduleMeeting>
            </div>
          )}
        {appointmentContactDetailsOpen && renderBookingForm()}
      </div>
    </React.Fragment>
  );
};

export default Booking;
